import React, { useContext, useEffect, useState } from "react";
import "./Login.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import bg from "./Bg.mp4";

import bg1 from "./bg1.jpg";
import bg2 from "./bg2.jpg";

const Login = (props) => {
  // structure
  const [password, setPassword] = useState();
  const [userName, setUser] = useState();
  const [email, setEmail] = useState();
  const navigate = useNavigate();
  const [login, setLogin] = useState("login");
  const [signup, setSign] = useState("sign_up");

  // functions
  useEffect(() => {
    if (Cookies.get("token")) navigate("home");
  }, [Cookies]);

  const handlesign = async () => {
    await setSign("login");
    await setLogin("sign_up");
  };

  const handlelogin = async () => {
    await setSign("sign_up");
    await setLogin("login");
  };

  //API CALL
  const onSubmitt = async () => {
    console.log("ss");
    try {
      const config = {
        headers: {
          "Content-type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${process.env.REACT_APP_URL}`,
        { userName, password },
        config
      );

      Cookies.set("token", data, { expires: 100 });
      console.log(Cookies.get("token"));
      navigate("/home");
    } catch (err) {
      alert("Invalid Email or Password");
      console.log(err.message);
    }
  };

  // signup call
  const onSignup = async () => {
    console.log("ss");
    try {
      const config = {
        headers: {
          "Content-type": "application/json",
        },
      };

      const data = await axios.post(
        `${process.env.REACT_APP_URL}signup`,
        { userName, password, email },
        config
      );
      if (data) {
        handlelogin();
        console.log("ss");
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  //RETURN
  return (
    <div className="whole">
      <img src={bg2} alt="" />

      <div className={login}>
        <div className="header">
          <h1>BLOG IT</h1>
        </div>
        <div className="card-login">
          <div className="i1">
            <input
              type="text"
              value={userName}
              placeholder="Username"
              onChange={(e) => setUser(e.target.value)}
            />
          </div>
          <div className="i1">
            <input
              type="text"
              value={password}
              placeholder="Password"
              onChange={(e) => setPassword(e.target.value)}
            ></input>
          </div>

          <button type="submit" onClick={() => onSubmitt(props)}>
            Log in
          </button>
          {/* <button
            onClick={() => {
              handlesign();
            }}
          >
            Sign up
          </button> */}
        </div>
      </div>

      <div className={signup}>
        <div className="header">
          <h1>BLOG IT</h1>
        </div>
        <div className="card-login">
          <input
            type="text"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <input
            type="text"
            placeholder="Username"
            value={userName}
            onChange={(e) => setUser(e.target.value)}
          />

          <input
            type="text"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          ></input>
          <button type="submit" onClick={() => onSignup()}>
            Sign up
          </button>
        </div>
      </div>
      <div className="sup">
        <p>
          Don't have an Account?{" "}
          <span
            onClick={() => {
              handlesign();
            }}
          >
            Sign up
          </span>
        </p>
      </div>
    </div>
  );
};

export default Login;
